import React from 'react';
import { Box } from '@wix/design-system';
import { ReviewsInfo } from '../reviews-info';
import { CTAButton } from '../cta-button';
import { AppIcon } from '../app-icon';
import { AppName } from '../app-name';
import { AppDeveloper } from '../app-developer';
import { AppTeaser } from '../app-teaser';
import { TopBadge } from '../top-badge';
import { useConsumerPreferences } from '../contexts/consumer-preferences';
import { PricingBadge } from '../pricing-badge';
import { InstalledBadge } from '../installed-badge';
import { useSolution } from '../contexts/solution';
export function NarrowAppBox() {
    const { showViewAppButton, showDeveloperName, showRating, showPricing, showTopBadge, skin, } = useConsumerPreferences();
    const { isBundleAppInstalled, isInstalled } = useSolution();
    const appTeaserMarginBottom = skin === 'List' ? '12px' : '24px';
    return (React.createElement(Box, { width: "100%", height: "100%", direction: "vertical", align: "space-between" },
        React.createElement(Box, { direction: "vertical" },
            React.createElement(Box, { marginBottom: "6px", align: "space-between" },
                React.createElement(AppIcon, null),
                showTopBadge ? React.createElement(TopBadge, null) : null),
            React.createElement(Box, { direction: "vertical" },
                React.createElement(Box, { direction: "vertical" },
                    React.createElement(AppName, null),
                    showDeveloperName && React.createElement(AppDeveloper, null)),
                React.createElement(Box, { marginTop: "6px", marginBottom: appTeaserMarginBottom },
                    React.createElement(AppTeaser, null)))),
        React.createElement(Box, { align: "space-between", verticalAlign: showViewAppButton ? 'bottom' : 'middle' },
            React.createElement(Box, { direction: "vertical", gap: "6px" },
                showRating && showViewAppButton && React.createElement(ReviewsInfo, null),
                isBundleAppInstalled || isInstalled ? (React.createElement(InstalledBadge, null)) : (showPricing && React.createElement(PricingBadge, null))),
            !showViewAppButton ? showRating && React.createElement(ReviewsInfo, null) : React.createElement(CTAButton, null))));
}
//# sourceMappingURL=NarrowAppBox.js.map